import React from "react";
import "../App.scss";

const Enjoy = () => {
  return (
    <div className="joy">
      <div className="joy_section">
        <h2 className="title">
          Things I enjoy{" "}
          <span role="img" aria-label="emoji">
            ❤️
          </span>
        </h2>
      </div>
      <div className="joy_section">
        <p>- Early morning air</p>
        <p>- Running long distances</p>
        <p>- Football (soccer)</p>
        <p>- Long walks with friends</p>
        <p>- Meditations</p>
        <p>- Yoga</p>
        <p>- Espresso</p>
        <p>- Hot tea</p>
        <p>- Pasta, lots of it</p>
        <p>- Kindle</p>
        <p>- Biographies</p>
        <p>- Maps</p>
        <p>- Photographies</p>
        <p>- Backpacks</p>
        <p>- White shoes</p>
        <p>- A clean car</p>
        <p>- Being on time</p>
        <p>- Egg sandwich</p>
        <p>- Panettone</p>
        <p>- Mascarpone</p>
        <p>- Cachapas</p>
        <p>- Fruits</p>
        <p>- Beach walks</p>
        <p>- Coconut water from a real coconut</p>
        <p>- Ironed clothes</p>
        <p>- Candles in the house</p>
        <p>- Fresh out of the dryer clothes/bed sheets</p>
        <p>- Throws blankets</p>
        <p>- Theragun Mini (massage gun)</p>
        <p>- French toast made with brioche bread</p>
        <p>- The smell of freshly cut grass</p>
      </div>
    </div>
  );
};

export default Enjoy;
